import { Map, fromJS } from 'immutable'
import * as actions from './actions'

export const initialState = Map()

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case actions.SET_COMMENTS_VISIBLE:
      return state.set('visible', action.payload)
    case actions.SET_COMMENTS_META_DATA:
      return state.withMutations((mutateState) => mutateState
        .set('contentId', action.payload.contentId)
        .set('visible', action.payload.visible)
        .set('metadata', fromJS(action.payload.metadata)))
    default:
      return state
  }
}
